'use client'
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import react_responsive from "react-responsive";
import { Drawer } from "../Drawer/index.js";
import { Popover } from "../Popover/index.js";
import { cleanProps } from "../../utils/index.js";
import { TRANSFORMER_MAX_MOBILE_WIDTH_PX, TRANSFORMER_MIN_DESKTOP_WIDTH_PX } from "../../utils/constants.js";
const CLEAN_PROPS = [
    'showCloseButton',
    'showDragHandle'
];
const DrawerToPopover = ({ defaultOpen, open, ...props })=>{
    const [isOpenState, setIsOpenState] = useState(defaultOpen);
    useEffect(()=>{
        setIsOpenState(defaultOpen || open);
    }, [
        defaultOpen,
        open
    ]);
    function handleOnOpenChange(open) {
        setIsOpenState(open);
        props.onOpenChange?.(open);
    }
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(react_responsive, {
                maxWidth: TRANSFORMER_MAX_MOBILE_WIDTH_PX,
                children: /*#__PURE__*/ jsx(Drawer, {
                    ...props,
                    open: isOpenState,
                    onOpenChange: handleOnOpenChange,
                    fadeFromIndex: void 0,
                    size: props.drawerSize
                })
            }),
            /*#__PURE__*/ jsx(react_responsive, {
                minWidth: TRANSFORMER_MIN_DESKTOP_WIDTH_PX,
                children: /*#__PURE__*/ jsx(Popover, {
                    ...cleanProps(props, CLEAN_PROPS),
                    open: isOpenState,
                    onOpenChange: handleOnOpenChange,
                    size: props.popoverSize,
                    openOnHover: false
                })
            })
        ]
    });
};
export { DrawerToPopover };
